@defer {
@if (adId()) {
@if (isAutoSize()) {
<!-- Auto Size - > {{ _width }} / {{ _height }} -->
<div #parent class="square__ad mx-auto" [style.width]="_width" [style.height]="_height">
  <span>
    AD
  </span><ins #ins class="adsbygoogle" style="display: block" [style.width]="_width" [style.height]="_height"
    [attr.data-ad-client]="adsnseID" data-ad-format="auto" data-full-width-responsive="true"
    [attr.data-ad-slot]="adId()" (click)="visitorService.adClicked(adId())"></ins>
</div>
} @else {
<!-- Fixed Size - > {{ _width }} / {{ _height }} -->

<div #parent class="square__ad mx-auto" [style.width]="_width" [style.height]="_height">
  <span>
    AD
  </span><ins #ins class="adsbygoogle" [style.width]="_width" [style.height]="_height" style="display: inline-block"
    [attr.data-ad-client]="adsnseID" [attr.data-ad-slot]="adId()" (click)="visitorService.adClicked(adId())"></ins>
</div>
}
}
}